export const GET_ERRORS = "GET_ERRORS";
export const UPDATE_RESULT = "UPDATE_RESULT";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const GET_USER_INFO = "GET_USER_INFO";
export const GET_GROUPE = "GET_GROUPE";
export const GET_ALL_TUTORIALS = "GET_ALL_TUTORIALS";
export const GET_CHAT_MESSAGES = "GET_CHAT_MESSAGES";
export const GET_USERS_LIST = "GET_USERS_LIST";
export const GET_STUDENT_GROUPES = "GET_STUDENT_GROUPES";
export const SERVER_URL = "";
export const UPDATE_USER_STATE = "UPDATE_USER_STATE";
export const UPDATE_FIELD_STATE = "UPDATE_FIELD_STATE";
export const UPDATE_SUBJECT_STATE = "UPDATE_SUBJECT_STATE";
export const UPDATE_GROUPE_LIST = "UPDATE_GROUPE_LIST";
export const ADD_FIELD = "ADD_FIELD";
export const ADD_GROUPE = "ADD_GROUPE";
export const SEND_CHAT_MESSAGE = "SEND_CHAT_MESSAGE";
export const UPDATE_GROUPE_STATE = "UPDATE_GROUPE_STATE";
export const JOIN_GROUPE = "JOIN_GROUPE";
export const LEAVE_GROUPE = "LEAVE_GROUPE";
export const ADD_SUBJECT = "ADD_SUBJECT";
export const GET_FIELD_LIST = "GET_FIELD_LIST";
export const GET_TUTORIAL = "GET_TUTORIAL";
export const GET_GROUPE_STUDENT_LIST = "GET_GROUPE_STUDENT_LIST";
export const GET_GROUPE_LIST = "GET_GROUPE_LIST";
export const GET_GROUPE_LIST_BY_TEACHER = "GET_GROUPE_LIST_BY_TEACHER";
export const GET_SUBJECT_LIST = "GET_SUBJECT_LIST";
export const ACCEPT_STUDENT_IN_GROUPE = "ACCEPT_STUDENT_IN_GROUPE";
export const ADD_COMMENT = "ADD_COMMENT";
export const GET_COMMENT_BY_TYPE = "GET_COMMENT_BY_TYPE";
export const DELETE_COMMENT = "DELETE_COMMENT";
export const ADD_QUESTIONNARY = "ADD_QUESTIONNARY";
export const DELETE_QUESTIONNARY = "DELETE_QUESTIONNARY";
export const  GET_PROFILE = "GET_PROFILE";
export const UPDATE_PROFILE_PICTURE = "UPDATE_PROFILE_PICTURE";
export const GET_TOTAL = "GET_TOTAL";



